import {
  getRequest,
  postRequest,
  postRequestByJson,
  getRequestOfExam,
  putRequest,
  getFileRequest,
  deleteRequest,
  uploadFileRequest,
} from "@/libs/axios";
// 课程分类-tree数据
import { Message } from "element-ui";
function myThen(data) {
  if (data.result) {
    return Promise.resolve(data.data);
  } else {
    Message.error(data.failMsg);
    return Promise.reject(data.failMsg);
  }
}

export const getExaminationType = (params = {}) => {
  return getRequestOfExam("/api/exam/query/group", params).then(myThen);
};
export const renameExaminationType = (params = {}) => {
  return postRequestByJson("/api/exam/update/group", params).then(myThen);
};
export const deleteExaminationType = (params = {}) => {
  return postRequestByJson("/api/exam/delete/group", params).then(myThen);
};
export const moveExaminationType = (params = {}) => {
  return postRequestByJson("/api/exam/move/group", params).then(myThen);
};
export const appendExaminationType = (params = {}) => {
  return postRequestByJson("/api/exam/create/group", params).then(myThen);
};

export const createExamination = (params = {}) => {
  return postRequestByJson("/api/exam/create", params).then(myThen);
};
export const formThePaper = (params = {}) => {
  return postRequestByJson("/api/exam/saveInfo", params).then(myThen);
};
export const getPaperQuestionData = (params = {}) => {
  return postRequestByJson("/api/exam/queryInfo", params).then(myThen);
};
export const getPaperList = (params = {}) => {
  return postRequestByJson("/api/exam/page/query", params).then(myThen);
};
export const uploadSign = (params = {}) => {
  return getRequestOfExam("/api/file/upload/parameter", params).then(myThen);
};
export const postPaperSetting = (params = {}) => {
  return postRequestByJson("/api/exam/save/set", params).then(myThen);
};
export const getSetting = (params = {}) => {
  return postRequestByJson("/api/exam/query/set", params).then(myThen);
};
export const getPaperData = (params = {}) => {
  return postRequestByJson("/api/exam/query", params).then(myThen);
};

export const editPaper = (params = {}) => {
  return postRequestByJson("/api/exam/edit", params).then(myThen);
};

export const deletePaperList = (params = {}) => {
  return postRequestByJson("/api/exam/delete", params).then(myThen);
};
export const getQuestion = (params = {}) => {
  return postRequestByJson("/api/exam/query/examInfo", params).then(myThen);
};
export const filePaper = (params = {}) => {
  return postRequestByJson("/api/exam/archive", params).then(myThen);
};
export const paperStatusEdit = (params = {}) => {
  return postRequestByJson("/api/exam/start", params).then(myThen);
};
export const getExaminationRecord = (params = {}) => {
  return postRequestByJson("/api/exam/v1/record-detail", params).then(myThen);
};
export const getExaminationRecordList = (params = {}) => {
  return postRequestByJson("/api/exam/v1/page/exam/detail", params).then(
    myThen
  );
};
export const videoWall = (params = {}) => {
  return postRequestByJson("/api/exam/v1/page/video-wall", params).then(myThen);
};
//考试记录分页列表
export const examRecordSearch = (params = {}) => {
  return postRequestByJson("/api/exam/v1/pageRecord", params).then(myThen);
};
//删除考试记录
export const deleteRecordList = (params = {}) => {
  return postRequestByJson("/api/exam/deleteRecord", params).then(myThen);
};
//查询阅卷信息
export const examQueryMarkExam = (params = {}) => {
  return postRequestByJson("/api/exam/v1/query/markExam", params).then(myThen);
}; //批卷信息保存
export const toMarkExam = (params = {}) => {
  return postRequestByJson("/api/exam/v1/mark/exam", params).then(myThen);
}; //查询下一份批卷信息
export const nextExamQueryMarkExam = (params = {}) => {
  return postRequestByJson("/api/exam/v1/query/nextMarkExam", params).then(
    myThen
  );
};
export const exportExamRecord = (params = {}) => {
  return getFileRequest("/api/file/download/exam-record", params);
};

export const getExamRecordDetail = (params = {}) => {
  return postRequestByJson("/api/exam/v1/record-detail", params).then(myThen);
};
export const getExamReport = (params = {}) => {
  return postRequestByJson("/api/student/v1/query/examReport", params).then(
    myThen
  );
};
export const movePaperGroup = (params = {}) => {
  return postRequestByJson("/api/exam/move", params).then(myThen);
};
export const getManualFaceCheckList = (params = {}) => {
  return postRequestByJson("/api/faceAudit/v1/page", params).then(myThen);
};
export const manualFaceCheck = (params = {}) => {
  return postRequest("/api/faceAudit/edit", params).then(myThen);
};
export const forceSubmitexam = (params = {}) => {
  return postRequestByJson("/api/exam/v1/exam/enforceSubmit", params).then(
    myThen
  );
};
